import {blockBannersSliderScript} from '../../blocks/sections-for-single-course/blocks/title_desc_slider_button/script';
import {blockPartnersSliderScript} from '../../blocks/sections-for-single-course/blocks/partners_slider/script';
import {accordionScript} from '../../blocks/sections-for-single-course/blocks/accordion/script';
import {blockOpinionsGfSliderScript} from '../../blocks/sections-for-single-course/blocks/reviews/script';
import {blockPackagesSliderScript} from '../../blocks/sections-for-single-course/blocks/packages/script';
import {blockSupportScript} from '../../blocks/sections-for-single-course/blocks/support/script';
import {blockTrainersSliderScript} from '../../blocks/sections-for-single-course/blocks/trainers/script';

if (document.querySelector('.title_desc_slider_button')) {
    blockBannersSliderScript()
}
;
if (document.querySelector('.partners')) {
    blockPartnersSliderScript()
}
;
if (document.querySelector('.accordion')) {
    accordionScript()
}
;
if (document.querySelector('.reviewsgf__slider')) {
    blockOpinionsGfSliderScript()
}
if (document.querySelector('.packages')) {
    blockPackagesSliderScript()
}
if (document.querySelector('.support')) {
    blockSupportScript()
}
if (document.querySelector('.trainers')) {
    blockTrainersSliderScript()
}


// Rejestracja pluginu ScrollTrigger

const links = document.querySelectorAll('.NB-sectionsForSingleCourse .menu_item a');
const desc_under_time_start = document.querySelectorAll('.desc_under_time_start');
const singleCourseMainBanner = document.querySelector('.NH-singleCourseMainBanner');
const pageheader = document.querySelector('.page-header');

links.forEach(link => {
    link.addEventListener('click', function (event) {
        removeActiveClass();
        event.preventDefault(); // Zapobiega domyślnemu działaniu linku

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetId === 'singleCourseMainBanner') {
            window.scrollTo({
                top: targetElement.offsetTop,
                behavior: 'smooth' // Płynne przewijanie
            });
        } else {
            window.scrollTo({
                top: targetElement.offsetTop + singleCourseMainBanner.offsetHeight + 20,
                behavior: 'smooth' // Płynne przewijanie
            });
        }
        setTimeout(() => {
            removeActiveClass(),
                link.classList.add('active')
        }, 100);
    });

});

const sections = document.querySelectorAll('.section-course');
window.addEventListener('scroll', () => {

    let currentSection = sections[0];
    sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (window.scrollY < singleCourseMainBanner.offsetHeight) {
            removeActiveClass();
            links[0].classList.add('active');
        }
        if (window.scrollY >= sectionTop + singleCourseMainBanner.offsetHeight) {
            currentSection = section;
        }
    });
    if (document.querySelector('.NB-sectionsForSingleCourse .menu_item')) {
        const currentLink = document.querySelector(`.NB-sectionsForSingleCourse .menu_item a[href="#${currentSection.id}"]`);
        if (currentLink) {
            if (!currentLink.classList.contains('active')) {
                removeActiveClass();
                currentLink.classList.add('active');
            }
        }
    }

    const menuParent = document.querySelector('.NB-sectionsForSingleCourse .menu-col .menu');
    const sectionsForSingleCourse = document.querySelector('.NB-sectionsForSingleCourse');
    if (sectionsForSingleCourse) {
        if (window.scrollY >= singleCourseMainBanner.offsetHeight + pageheader.offsetHeight) {
            menuParent.style.position = 'fixed';
            if (window.scrollY >= singleCourseMainBanner.offsetHeight + pageheader.offsetHeight + sectionsForSingleCourse.offsetHeight - sections[sections.length - 1].offsetHeight - 100) {
                menuParent.style.position = 'sticky';
            }
        } else {
            menuParent.style.position = 'sticky';
        }
    }


});

function removeActiveClass() {
    links.forEach(link => {
        link.classList.remove('active');
    });
}

if(desc_under_time_start) {
    desc_under_time_start.forEach(link => {
        link.addEventListener('click', function (event) {
            removeActiveClass();
            event.preventDefault(); // Zapobiega domyślnemu działaniu linku

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            window.scrollTo({
                top: targetElement.offsetTop + singleCourseMainBanner.offsetHeight + 20,
                behavior: 'smooth' // Płynne przewijanie
            });
            setTimeout(() => {
                removeActiveClass(),
                    link.classList.add('active')
            }, 100);
        });
    });
}


const price_plans = document.querySelectorAll('.price_plans a');
if(price_plans) {
    price_plans.forEach(link => {
        link.addEventListener('click', function (event) {
            removeActiveClass();
            event.preventDefault(); // Zapobiega domyślnemu działaniu linku
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            window.scrollTo({
                top: targetElement.offsetTop + singleCourseMainBanner.offsetHeight + 20,
                behavior: 'smooth' // Płynne przewijanie
            });
            setTimeout(() => {
                removeActiveClass(),
                    link.classList.add('active')
            }, 100);
        });
    });
}
